"use strict";
import { onCleanup } from "solid-js";
import autoproduce from "./autoproduce.js";
import { createStore, produce, reconcile } from "solid-js/store";
const cache = /* @__PURE__ */ new WeakMap();
export default function makeDocumentProjection(handle) {
  onCleanup(() => {
    const item = cache.get(handle);
    if (!item) return;
    if (!item.refs--) {
      item.cleanup();
    }
  });
  if (cache.has(handle)) {
    const item = cache.get(handle);
    item.refs++;
    return item.store;
  }
  const [doc, set] = createStore(handle.doc());
  cache.set(handle, {
    refs: 0,
    store: doc,
    cleanup() {
      handle.off("change", patch);
      handle.off("delete", ondelete);
      cache.delete(handle);
    }
  });
  function patch(payload) {
    set(produce(autoproduce(payload)));
  }
  function ondelete() {
    set(reconcile({}));
  }
  handle.on("change", patch);
  handle.on("delete", ondelete);
  handle.whenReady().then(() => {
    set(handle.doc());
  });
  return doc;
}
//# sourceMappingURL=makeDocumentProjection.js.map
